import { html, css, LitElement, property } from 'lit-element';
import { XdsStylesButton } from './XdsStylesButton';

export class XdsCoreButton extends LitElement {
  static styles = [
    XdsStylesButton,
    css`
      :host {
        display: block;
        color: var(--xds-core-button-text-color, #000);
      }
    `,
  ];

  @property({ type: String, attribute: 'id' }) id = '';

  @property({ type: String, attribute: 'name' }) name = '';

  @property({ type: String, attribute: 'text' }) text = '';

  @property({ type: String, attribute: 'style-variant' }) styleVariant =
    'xds-button default';

  @property({
    type: Boolean,
    converter: value => value === 'true',
    attribute: 'disabled',
  })
  isDisabled = false;

  /*
   * Potomac Tracking
   */
  firstUpdated() {
    const potomacCustomEvent = new CustomEvent('caliper-custom-interaction', {
      detail: {
        action: 'xds-web-component-view',
        elementName: '@cof/xds-core-button',
        elementType: 'modal',
        elementValue: JSON.stringify({
          webComponentVersion: '1.0.4',
        }),
      },
    });
    document.dispatchEvent(potomacCustomEvent);

    // If the component loads before snowplow,
    // then emit the event within 'snowplow:loaded' event listener
    document.addEventListener('snowplow:loaded', () => {
      document.dispatchEvent(potomacCustomEvent);
    });
  }

  /*
  Getters and setters
  */
  getId = () => this.id.replace(/\s+/, '').toLowerCase();

  /*
   * Events
   */

  static setCustomEvent(
    elementName: any,
    eventType: string,
    elementSource: string,
    elementId: any,
    elementText: string,
    elementStyleVariant: string
  ) {
    const objPayload = {
      name: elementName,
      id: elementId,
      text: elementText,
      styleVariant: elementStyleVariant,
    };

    const event = new CustomEvent(eventType, {
      detail: {
        source: elementSource,
        payload: objPayload,
      },
    });

    return event;
  }

  // eslint-disable-next-line class-methods-use-this
  _onClick(event: any) {
    const eventToBeEmitted = XdsCoreButton.setCustomEvent(
      event != null ? event.target.name : '',
      'xds-core:button.click',
      'xds-core-button',
      event != null ? event.target.id : '',
      this.text,
      this.styleVariant
    );
    this.dispatchEvent(eventToBeEmitted);
    eventToBeEmitted.stopPropagation();
  }

  render() {
    return html`
      <button
        id="button-${this.getId()}"
        class=${this.styleVariant}
        name=${this.name}
        ?disabled=${this.isDisabled}
        @click="${(e: Event) => this._onClick(e)}"
      >
        <slot name="content">${this.text}</slot>
      </button>
    `;
  }
}
